export default __webpack_public_path__ + "static/media/PreventionAGBs.dc11cbf9.md";